module.exports = __webpack_public_path__ + "img/weixin.a4eec336.svg";